<template>
    <navBar title="Ares - Guest messages" :home="true" type="guestmessages"/>
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';
    export default {
        components: {
            navBar,
        },
    }

</script>